<script setup>
import { defineProps } from 'vue';
import { PhxsgButton } from '@sg/src/View/Components/Atoms/Button';
import PhxPicture from '@maison/components/common/PhxPicture.vue';

defineProps({
  name: {
    type: String,
    required: true,
  },
  modelReference: {
    type: String,
    required: true,
  },
  movementLabel: {
    type: String,
    required: true,
  },
  image: {
    type: Object,
    required: true,
  },
});
</script>

<template>
  <div class="movements-grid__item">
    <div class="movements-grid__item-media">
      <div v-if="image" class="picture picture--contain movements-grid__picture">
        <PhxPicture lazy v-bind="image" />
      </div>
    </div>

    <phxsg-button
      use="button"
      variant="link"
      expand-target
      :data-cy-reference="modelReference"
      class="movements-grid__item-label"
    >
      {{ movementLabel }}
    </phxsg-button>
  </div>
</template>
